import { 
    Briefcase, 
    HandCoins, 
    ShieldCheck, 
    FileText, 
    Star,
    Home,
    User,
    Building2,
    Car,
    Factory,
    Scale,
    TrendingUp,
    Search,
    PieChart,
    CheckCircle2,
    Laptop,
    Globe,
    Smartphone,
    SearchCheck,
    Megaphone,
    GraduationCap,
    Cpu,
    Coins,
    UserCheck,
    Truck,
    Settings,
    Code,
    Activity,
    LineChart,
    Gavel,
    ShieldAlert,
    Cloud,
    BookOpen,
    Store,
    Plane,
    HeartPulse,
    Bike,
    ShieldHalf
} from 'lucide-react';

export const servicesData = {
    businessConsultancy: {
        title: 'Business Consultancy',
        icon: <Briefcase />,
        color: 'from-blue-600 to-indigo-600',
        image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2426&auto=format&fit=crop',
        description: 'Professional guidance for sustainable business growth and financial stability.',
        items: [
            { name: 'Business Growth Planning', desc: 'Strategic roadmaps to scale your operations.', icon: <TrendingUp size={20} /> },
            { name: 'Financial Planning', desc: 'Expert advice on managing assets and investments.', icon: <PieChart size={20} /> },
            { name: 'Market Research', desc: 'In-depth analysis of industry trends and competitors.', icon: <Search size={20} /> },
            { name: 'Project Feasibility Reports', desc: 'Detailed assessment of new project viability.', icon: <FileText size={20} /> },
            { name: 'Risk Management', desc: 'Identifying and mitigating business risks.', icon: <ShieldAlert size={20} /> },
            { name: 'Startup Mentorship', desc: 'End-to-end guidance for new entrepreneurs.', icon: <GraduationCap size={20} /> }
        ]
    },
    loanServices: {
        title: 'Loan Services',
        icon: <HandCoins />,
        color: 'from-emerald-600 to-teal-600',
        image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=2511&auto=format&fit=crop',
        description: 'Flexible loan solutions with competitive interest rates and quick processing.',
        items: [
            { name: 'Home Loan', desc: 'Realize your dream of owning a home.', icon: <Home size={20} /> },
            { name: 'Personal Loan', desc: 'Instant funds for your personal needs.', icon: <User size={20} /> },
            { name: 'Business Loan', desc: 'Fuel your business expansion.', icon: <Briefcase size={20} /> },
            { name: 'Property Loan (LAP)', desc: 'Unlock value from your property.', icon: <Building2 size={20} /> },
            { name: 'Vehicle Loan', desc: 'Finance your new car or bike easily.', icon: <Car size={20} /> },
            { name: 'MSME / Mudra Loan', desc: 'Support for small and medium enterprises.', icon: <Factory size={20} /> },
            { name: 'Government Scheme Loans', desc: 'Loans under PMEGP, PMFME, etc.', icon: <Scale size={20} /> },
            { name: 'Education Loan', desc: 'Finance higher studies in India or abroad.', icon: <BookOpen size={20} /> },
            { name: 'Gold Loan', desc: 'Instant cash against your gold jewelry.', icon: <Coins size={20} /> }
        ]
    },
    insuranceServices: {
        title: 'Insurance Services',
        icon: <ShieldCheck />,
        color: 'from-amber-500 to-orange-600',
        image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=2370&auto=format&fit=crop',
        description: 'Comprehensive protection for your life, health, and assets.',
        items: [
            { name: 'Life Insurance', desc: 'Secure your family\'s future.', icon: <HeartPulse size={20} /> },
            { name: 'Health Insurance', desc: 'Quality medical care for your loved ones.', icon: <Activity size={20} /> },
            { name: 'Car Insurance', desc: 'Full coverage for your four-wheeler against accidents and theft.', icon: <Car size={20} /> },
            { name: 'Bike Insurance', desc: 'Affordable protection for your two-wheeler.', icon: <Bike size={20} /> },
            { name: 'General Insurance', desc: 'Coverage for home, travel, and more.', icon: <ShieldHalf size={20} /> },
            { name: 'Travel Insurance', desc: 'Stay protected during domestic and international trips.', icon: <Plane size={20} /> },
            { name: 'Shopkeeper Insurance', desc: 'Security for your business premises and stock.', icon: <Store size={20} /> }
        ]
    },
    complianceServices: {
        title: 'Business Compliance',
        icon: <FileText />,
        color: 'from-rose-600 to-pink-600',
        image: 'https://images.unsplash.com/photo-1554224154-26032ffc0d07?q=80&w=2326&auto=format&fit=crop',
        description: 'Ensure your business meets all legal and regulatory requirements.',
        items: [
            { name: 'ITR Filing', desc: 'Accurate and timely income tax returns.', icon: <FileText size={20} /> },
            { name: 'GST Filing', desc: 'Hassle-free GST compliance and filing.', icon: <CheckCircle2 size={20} /> },
            { name: 'Bookkeeping & Audit', desc: 'Maintain clear and professional accounts.', icon: <Coins size={20} /> },
            { name: 'ROC Compliance', desc: 'Manage company law requirements efficiently.', icon: <UserCheck size={20} /> },
            { name: 'MSME Registration', desc: 'Get Udyam registration for government benefits.', icon: <FileText size={20} /> },
            { name: 'Trade License', desc: 'Obtain necessary municipal approvals for business.', icon: <Gavel size={20} /> }
        ]
    },
    itDigitalServices: {
        title: 'IT & Digital Services',
        icon: <Laptop />,
        color: 'from-violet-600 to-purple-600',
        image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2370&auto=format&fit=crop',
        description: 'Empowering your business with cutting-edge software and digital solutions.',
        items: [
            { name: 'Software Development', desc: 'Custom ERP, CRM, billing and enterprise software.', icon: <Code size={20} /> },
            { name: 'Website Development', desc: 'Professional e-commerce and corporate websites.', icon: <Globe size={20} /> },
            { name: 'Mobile App Development', desc: 'Android, iOS and hybrid mobile applications.', icon: <Smartphone size={20} /> },
            { name: 'SEO Services', desc: 'Search Engine Optimization and Google Business Profile.', icon: <SearchCheck size={20} /> },
            { name: 'Digital Marketing', desc: 'Social media marketing and lead generation.', icon: <Megaphone size={20} /> },
            { name: 'Cloud Solutions', desc: 'Reliable cloud hosting and data management.', icon: <Cloud size={20} /> },
            { name: 'Cyber Security', desc: 'Protecting your digital assets and user data.', icon: <ShieldAlert size={20} /> }
        ]
    },
    specialServices: {
        title: 'Special Services',
        icon: <Star />,
        color: 'from-cyan-500 to-blue-500',
        image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2370&auto=format&fit=crop',
        description: 'Customized solutions for specific financial challenges.',
        items: [
            { name: 'CIBIL Improvement', desc: 'Boost your credit score for better loan eligibility.', icon: <LineChart size={20} /> },
            { name: 'Balance Transfer', desc: 'Reduce your EMI by transferring existing loans.', icon: <HandCoins size={20} /> },
            { name: 'Loan Consultancy', desc: 'Expert guidance on choosing the right loan.', icon: <Briefcase size={20} /> },
            { name: 'Debt Consolidation', desc: 'Combine multiple debts into a single manageable payment.', icon: <Coins size={20} /> },
            { name: 'Wealth Management', desc: 'Strategic planning for long-term wealth creation.', icon: <TrendingUp size={20} /> }
        ]
    }
};
